import { GroupAuthorityManagementPage } from "./GroupAuthorityManagementPage";
export default GroupAuthorityManagementPage;
